import api from "./api";

// Fetch all Starter Kit Purchases
export const fetchStarterKitPurchases = async (
  page = 1,
  size = 10
) => {
  try {
    const response = await api.get(
      "/starter-kit-purchase-management/list",
      {
        params: {
          page,
          size,
        },
      }
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error: "Unexpected response from server",
    };

  } catch (error) {
    console.error(
      "Error fetching Starter Kit Purchases:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch Starter Kit Purchases",
    };
  }
};


// Fetch all Starter Kit Payment Proofs
export const fetchStarterKitPaymentProofs = async (
  page = 1,
  size = 10
) => {
  try {
    const response = await api.get(
      "/starter-kit-purchase-payment-proof-management/list",
      {
        params: {
          page,
          size,
        },
      }
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error: "Unexpected response from server",
    };

  } catch (error) {
    console.error(
      "Error fetching Starter Kit Payment Proofs:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to fetch Starter Kit Payment Proofs",
    };
  }
};


// Update Starter Kit Payment Proof
export const updateStarterKitPaymentProof = async (
  paymentId,
  status,
  statusReason
) => {
  try {
    const payload = {
      status,
      status_reason: statusReason,
    };

    const response = await api.put(
      `/starter-kit-purchase-payment-proof-management/update/admin/${paymentId}`,
      payload
    );

    if (
      response.status === 200 &&
      response.data.success
    ) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error:
        response.data?.message ||
        "Unexpected response from server",
    };

  } catch (error) {
    console.error(
      "Error updating Starter Kit Payment Proof:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.response?.data?.detail ||
        error.message ||
        "Failed to update Starter Kit Payment Proof",
    };
  }
};